import { inject, Injectable } from '@angular/core';
import { RestApiService } from '@services/rest-api/rest-api.service';
import { API_PATH } from '@shared/tokens';
import { Observable } from 'rxjs';
import { LaximoTokensState } from '../../../modules/catalog/laximo/models/laximo-tokens-state.interface';

@Injectable({
  providedIn: 'root',
})
export class LaximoTokensStateService {
  private readonly apiPath = inject(API_PATH);
  private readonly http = inject(RestApiService);

  getState(): Observable<LaximoTokensState> {
    return this.http.get<LaximoTokensState>(`${this.apiPath}/laximo-tokens/state`);
  }

  markWarnShown(): Observable<void> {
    return this.http.post<void, null>(`${this.apiPath}/laximo-tokens/warn-shown`, null);
  }
}
